<script setup>

import { computed, ref } from "vue";
import ListaDePagamentosEletronicos from "./ListaDePagamentosEletronicos/ListaDePagamentosEletronicos.vue";
import VisualizarPagamentoEletronico from "./VisualizarPagamentosEletronicos/VisualizarPagamentoEletronico.vue";
import PagamentoEletronicoDeFolhaDePagamento from "../../api/v2/services/PagamentoEletronicoDeFolhaDePagamento.js"
import PagamentoEletronicoDeFerias from "../../api/v2/services/PagamentoEletronicoDeFerias";
import PagamentoEletronicoDePencaoAlimenticia from "../../api/v2/services/PagamentoEletronicoDePencaoAlimenticia";
import PagamentoEletronicoDeRescicao from "../../api/v2/services/PagamentoEletronicoDeRescisao";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//=============== Visualizando Pagamento Eletronico ================//
//==================================================================//

const visualizandoPagamentoEletronico = ref(false);

//==================================================================//
//====================== Pagamento Eletronico ======================//
//==================================================================//

const pagamentosEletronicos = ref([]);
const pagamentoEletronico = ref({});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update) => {

    controlesDesativados.value = update;

}

//==================================================================//
//================ Altera Pagamentos Eletronicos ===================//
//==================================================================//

const alteraPagamentosEletronicos = (update=[])=>{

    pagamentosEletronicos.value = update;

};

//==================================================================//
//=============== Altera Pagamento Eletronico ======================//
//==================================================================//

const alteraPagamentoEletronico = (update={})=>{

    pagamentoEletronico.value = update

};

//==================================================================//
//================ Pagamento Eletronico Service ====================//
//==================================================================//

const SERVICES = {
    PEFP: PagamentoEletronicoDeFolhaDePagamento,
    PEF:  PagamentoEletronicoDeFerias,
    PER:  PagamentoEletronicoDeRescicao,
    PEPA: PagamentoEletronicoDePencaoAlimenticia
}

const pagamentoEletronicoService = computed(()=>{

    return SERVICES[pagamentoEletronico?.value?.sigla];

});

//==================================================================//
//=========== Altera Visualizando Pagamento Eletronico =============//
//==================================================================//

const alteraVisualizandoPagamentoEletronico = (update={})=>{

    visualizandoPagamentoEletronico.value = update.visualizandoPagamentoEletronico;
    alteraPagamentoEletronico(update?.pagamentoEletronico);

};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Pagamentos dos Colaboradores
        </h2>

        <ListaDePagamentosEletronicos
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pagamentosEletronicos="pagamentosEletronicos"
            :visualizandoPagamentoEletronico="visualizandoPagamentoEletronico"
            :controlesDesativados="controlesDesativados"
            @update:pagamentosEletronicos="alteraPagamentosEletronicos"
            @update:pagamentoEletronico="alteraPagamentoEletronico"
            @update:visualizandoPagamentoEletronico="alteraVisualizandoPagamentoEletronico"
            @update:controlesDesativados="alteraControlesDesativados"
        ></ListaDePagamentosEletronicos>

        <VisualizarPagamentoEletronico
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pagamentoEletronico="pagamentoEletronico"
            :pagamentoEletronicoService="pagamentoEletronicoService"
            :controlesDesativados="controlesDesativados"
            :visualizandoPagamentoEletronico="visualizandoPagamentoEletronico"
            @update:pagamentoEletronico="alteraPagamentoEletronico"
            @update:visualizandoPagamentoEletronico="alteraVisualizandoPagamentoEletronico"
            @update:controlesDesativados="alteraControlesDesativados"
        ></VisualizarPagamentoEletronico>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>